import "devextreme/dist/css/dx.fluent.blue.light.css";

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "@/CommonVueCore/src/store/store"; //pinia
import localization from "./localization/localization";
import { useLangStore } from "@/CommonVueCore/src/store/stores/langStores";
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import jquery from "jquery";
import moment from "moment";

import "@/CommonVueCore/src/global/coreGlobalThemeImports.js";
import "@/global/globalThemeImports.js";
import {
  appSettingsInject,
  registerServiceClients,
  registerServices,
} from "@/dependencyResolver/resolver.js";
import { resolveDirectives } from "@/dependencyResolver/directivesResolver";
import { AppSettingsBinder } from "@/services/configBinderService";
import "@/assets/css/animate.min.css";

import VueApexCharts from "vue3-apexcharts";

/* Formkit Start */
import { plugin, defaultConfig } from "@formkit/vue";
import "@formkit/themes/genesis";
import { indexRoutes } from "@/searchEngine/indexRoutes";
import { Tooltip } from "bootstrap";
/* Formkit End */

var app = createApp(App);

window.$ = window.jQuery = jquery;
window.moment = moment;

window.onunhandledrejection = (event) => {
  console.error("HATA: ", event.reason);

  router.push({
    path: "/errorPage",
    query: { errorMsg: event.reason, errorCode: 500 },
  });
  // ekranda hata patlamamasi icin
  event.preventDefault();
};

app.config.errorHandler = (err, instance, info) => {
  // Hatayı konsola loglayabilirsiniz (sadece geliştiriciler için)
  router.push({ path: "/errorPage", query: { errorMsg: err, errorCode: 500 } });
  console.error("Vue Error Handler:", err);
};

app.directive("tooltip", (el) => {
  new Tooltip(el);
});

app.use(VueApexCharts);

var configBinder = new AppSettingsBinder();
await configBinder.appSettingsBinder();

try {
  registerServiceClients(app);
  registerServices(app);
} catch (error) {
  console.error(error);
}
// resolveDirectives(app);

app.use(store);
app.use(localization);
app.use(router);

app.use(plugin, defaultConfig());
// app.use(VueReCaptcha, { // reCAPTCHA v3
//   siteKey: window.appsettings.AppGlobal.ReCaptcha.V3SiteKey,
//   loaderOptions: {
//     autoHideBadge: true, // reCAPTCHA logosunu gizler (opsiyonel)
//   },
// });

export const useGlobals = () => app.config.globalProperties;
const langStore = useLangStore();
localization.global.locale =
  langStore.getLangInfo ?? window.appsettings.AppGlobal.DefaultLanguage;
app.config.globalProperties.$t = localization.global.t;
app.config.globalProperties.$jquery = jquery;
window.$t = localization.global.t;

app.mount("#app");
